import AdminUserDetails from './AdminUserDetails';
import AdminUsers from './AdminUsers';

export {
    AdminUserDetails,
    AdminUsers,
};

export default AdminUsers;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Users/index.tsx